export const setPage = (args, state, utils) => {
  utils.changeValue(state, "page", () => args[0])
}
// store searched fields
export const setSearch = (args, state, utils) => {
  utils.changeValue(state, "searched", () => state.lastFormState.values)
}
export const openFormCreate = (args, state, utils) => {
  utils.changeValue(state, "formOpen", () => "create")
}
export const openFormEdit = (_id, state, utils) => {
  utils.changeValue(state, "formOpen", () => _id[0])
}
export const closeForm = (_id, state, utils) => {
  utils.changeValue(state, "formOpen", () => null)
}
export const setActive = (args, state, utils) => {
  utils.changeValue(state, "active", () => args[0])
}
